import CommonLogin from '../../../common/pages/public/Login'

class Login extends CommonLogin {
  constructor (props) {
    super(props)
    this.loginFormTitle = '日本型枠工事業協会 [事務局]'
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/admin/pages/public/Login.js